import React from 'react';
import styled from 'styled-components';
import Button from '../forms/button';
import ModalContainer from './modalcontainer';
import { withTheme } from 'styled-components';

const Container = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

const Toolbar = styled.div`
	flex-shrink: 0;
	display: flex;
	.ps-button {
		&:not(:last-child) {
			margin-right: 32px;
		}
	}
	* {
		vertical-align: middle;
	}
`;

const ToolbarLeft = styled.div`
	flex-shrink: 0;
	flex-grow: 0;
`;

const ToolbarCenter = styled.div`
	flex-grow: 1;
	text-align: center;
`;

const ToolbarRight = styled.div`
	flex-grow: 0;
	flex-shrink: 0;
`;

const Header = styled.div`
	display: inline-block;
`;

const Content = styled.div`
	flex-grow: 1;
	overflow: auto;
`;

class ModuleContainer extends React.Component {

	render() {
		const bottomToolbar = false;//this.props.theme.moduleBottomToolbar;
		const topToolbar = !bottomToolbar;
		return (
			<Container>
				<Toolbar>
					<ToolbarLeft>
						{topToolbar && this.props.toolbarLeft}
						<Header>{this.props.header}</Header>
					</ToolbarLeft>
					<ToolbarCenter>
						{topToolbar && this.props.toolbarCenter}
					</ToolbarCenter>
					<ToolbarRight>
						{topToolbar && this.props.toolbarRight}
					</ToolbarRight>
				</Toolbar>
				<Content>{this.props.children}</Content>
				{
					bottomToolbar && (
						<Toolbar>
							<ToolbarLeft>
								{this.props.toolbarLeft}
							</ToolbarLeft>
							<ToolbarCenter>
								{this.props.toolbarCenter}
							</ToolbarCenter>
							<ToolbarRight>
								{this.props.toolbarRight}
							</ToolbarRight>
						</Toolbar>
					)
				}
				{
					this.props.modalDialog && (
						<ModalContainer noCenterer={this.props.noModalCenterer}>
							{this.props.modalDialog}
						</ModalContainer>
					)
				}
			</Container>
		);
	}
}

export default (ModuleContainer);